// extracted by mini-css-extract-plugin
module.exports = {"normalBtn":"normalBtn--1Vqur"};